module.exports = "<div class=\"centered-notice\">\n  {{t \"webapp.agents.results.result_list.start_research_notice\"}}\n</div>\n"